import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import Vant from 'vant'
import { Lazyload } from 'vant'
import 'vant/lib/index.css'
import './assets/css/common.css'
import Api from './assets/js/api.js'
import Qiniu from './assets/js/qiniu.js'
import Hawutil from './assets/js/hawutil.js'
import App from './App.vue'


Vue.prototype.$api = Api
Vue.prototype.$qiniu = Qiniu
Vue.prototype.$hawutil = Hawutil
Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(Vuex)
Vue.use(VueRouter)


const Routers = [
  {
    path: '/',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/message_choose.vue'], resolve)
  },
  {
    path: '*',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/message_choose.vue'], resolve)
  },
  {
    path: '/loading',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/loading.vue'], resolve)
  },
  {
    path: '/complain',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/complain.vue'], resolve)
  },
  {
    path: '/complain_edit',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/complain_edit.vue'], resolve)
  },
  {
    path: '/message_choose',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/message_choose.vue'], resolve)
  },
  {
    path: '/message_check',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/message_check_with_subscribe.vue'], resolve)
  },
  {
    path: '/message_check_with_subscribe',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/message_check_with_subscribe.vue'], resolve)
  },
  {
    path: '/message_create',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/message_create_free.vue'], resolve)
  },
  {
    path: '/message_create_combo',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/message_create_free.vue'], resolve)
  },
  {
    path: '/message_create_free',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/message_create_free.vue'], resolve)
  },
  {
    path: '/message_modify/:info_id',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/message_modify.vue'], resolve)
  },
  {
    path: '/message_records',
    meta: {
      title: '我写的留言'
    },
    component: (resolve) => require(['./views/message_records.vue'], resolve)
  },
  {
    path: '/community_rules',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/community_rules.vue'], resolve)
  },
  {
    path: '/supervise_message_check',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/supervise_message_check.vue'], resolve)
  },
  {
    path: '/supervise_message_modify/:id',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/supervise_message_modify.vue'], resolve)
  },
  {
    path: '/user_center',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/user_center.vue'], resolve)
  },
  {
    path: '/feedback_edit',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/feedback_edit.vue'], resolve)
  },
  {
    path: '/bought',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/bought.vue'], resolve)
  },
  {
    path: '/refund_apply/:id',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/refund_apply.vue'], resolve)
  },
  {
    path: '/special_focus_records',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/special_focus_records.vue'], resolve)
  },
]

const RouterConfig = {
  mode: 'history',
  routes: Routers
}
const router = new VueRouter(RouterConfig)

const store = new Vuex.Store({
  state: {
    userinfo: {
      headimg: '',
      nickname: '',
      openid: '',
      subscribe: 0,
      silent: 0,
      notice: true
    },
    favicon: 'https://static.huiyiji520.com/960401561-1702436401.jpg',
    staticUrl: 'https://static.huiyiji520.com',
    siteDomain: 'https://love.ypzhushou.com',
    webAuthUrl: 'https://love.missmoontalk.com/dengjipai',
    siteTitle: '西柚信箱',
    siteSlogan: '这里有你的故事',
    siteCode: 'dengjipai'
  },

  mutations: {
    setUserinfo (state, params){
      // alert('nickname: ' + params.nickname)
      state.userinfo = {headimg: params.headimg, nickname: params.nickname, openid: params.openid, subscribe: params.subscribe, silent: params.silent, notice: params.notice}
      // alert('setuserinfo destination: ' + params.destination)
      if(params.destination){
        router.replace(params.destination)
      }
    },
    updateUserNotice(state, params){
      state.userinfo.notice = params.notice
    }
  }
});

router.beforeEach((to, from, next) => {
  // alert('store state userinfo openid: ' + store.state.userinfo.openid)
  // alert('to url: ' + JSON.stringify(to))
  window.document.title = to.meta.title || store.state.siteTitle
  if( (to.path === "/loading") || (to.path === "/") || (to.path === "/message_choose") ){
    next()
  }else if(store.state.userinfo.openid){
    next()
  }else{
    // next()
    window.location.replace("https://api.huiyiji520.com/api/shanzhadao/snsapi_userinfo?url=" + store.state.webAuthUrl + "/loading?destination=" + encodeURIComponent(to.fullPath))
  }
})

new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => {
    return h(App)
  }
})
